import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import ScienceClubSideBar from '../ScienceClubSideBar';
import Sidebar2026 from '../ScienceClub/Sidebar2026';

const ScienceAssociation6to82026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Science/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Science/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Science/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Science/4.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1.5,
            cols: 1,
        },
       
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                                   ACTIVITY: MYTH BUSTERS – DECODE & DRAW
                                </Typography>
                                <br />
                                <Typography
                                    fontSize="x-small"
                                > <br />
                                    CLASS: 6-8   Date: 25-07-2026
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The <strong>Junior Science Association </strong>successfully organised<strong> ‘Myth Busters – Decode & Draw,’ </strong>an engaging and
interactive event designed to enhance scientific thinking, promote curiosity and dispel common scientific
myths and misconceptions for students of Classes 6, 7 and 8 on Friday, 17 July 2026. The event commenced
with the<strong> ‘Myth or Fact Quiz,’ </strong>which served as the elimination round. The preliminary round tested
participant's analytical thinking and scientific reasoning. Based on their performance, the top-scoring teams
qualified for the final round which was held on Saturday, 25 July 2026. Each team then delivered a <strong>3-minute
presentation,</strong> explaining the scientific concept, the message conveyed through their creation, and how
creativity and humour was used to communicate the idea effectively.      
                         <br/>
                         The event successfully fulfilled the objectives of the Junior Science Association by fostering scientific temper,
innovation and collaborative learning among participants.
                                <br />
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
‘MYTHS BUSTED, MINDS ENLIGHTENED’
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar2026 />
                        </Box>
                        <Box marginBottom={4}>
                            <ScienceClubSideBar />

                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default ScienceAssociation6to82026;